import { Action } from '@ngrx/store';

// Get all performances
export const GET_ALL_PERFORMANCES = '[Entertainment Event] Get All Performances';
export const GET_ALL_PERFORMANCES_SUCCESS = '[Entertainment Event] Get All Performances Success';
export const GET_ALL_PERFORMANCES_FAIL = '[Entertainment Event] Get All Performances Fail';

export class GetAllPerformances implements Action {
  readonly type = GET_ALL_PERFORMANCES;
  constructor(public payload: any) {}
}

export class GetAllPerformancesSuccess implements Action {
  readonly type = GET_ALL_PERFORMANCES_SUCCESS;
  constructor(public payload: any) {}
}

export class GetAllPerformancesFail implements Action {
  readonly type = GET_ALL_PERFORMANCES_FAIL;
  constructor(public payload: any) {}
}

// Get individual performance
export const GET_INDIVIDUAL_PERFORMANCE = '[Entertainment Event] Get Individual Performance';
export const GET_INDIVIDUAL_PERFORMANCE_SUCCESS = '[Entertainment Event] Get Individual Performance Success';
export const GET_INDIVIDUAL_PERFORMANCE_FAIL = '[Entertainment Event] Get Individual Performance Fail';

export class GetIndividualPerformance implements Action {
  readonly type = GET_INDIVIDUAL_PERFORMANCE;
  constructor(public payload: any) {}
}

export class GetIndividualPerformanceSuccess implements Action {
  readonly type = GET_INDIVIDUAL_PERFORMANCE_SUCCESS;
  constructor(public payload: any) {}
}

export class GetIndividualPerformanceFail implements Action {
  readonly type = GET_INDIVIDUAL_PERFORMANCE_FAIL;
  constructor(public payload: any) {}
}

export const RESET_ALL_PERFORMANCES = '[Entertainment Event] Reset All Performances';
export const RESET_INDIVIDUAL_PERFORMANCE = '[Entertainment Event] Reset Individual Performance';

export class ResetAllPerformances implements Action {
  readonly type = RESET_ALL_PERFORMANCES;
}

export class ResetIndividualPerformance implements Action {
  readonly type = RESET_INDIVIDUAL_PERFORMANCE;
}

export type EntertainmentEventPerformancesAction =
  | GetAllPerformances
  | GetAllPerformancesSuccess
  | GetAllPerformancesFail
  | GetIndividualPerformance
  | GetIndividualPerformanceSuccess
  | GetIndividualPerformanceFail
  | ResetAllPerformances
  | ResetIndividualPerformance;
